import { analiticaInstance } from 'shared/analitica'

import { type Analytics } from '~/domains/home-v2/types'

const commonProperties = {
  owner: 'home',
  product: 'home',
  project: 'stone',
  screen: 'home'
}

export default analiticaInstance.eventFactory('Sidebar', {
  mainMenu: {
    /**
     * @analitica When the user click on lateral menu
     */
    click: (analytics: Analytics) => ({
      label: analytics?.eventName,
      metadata: {
        properties: analytics?.properties,
        option: analytics?.option,
        type: analytics?.type
      }
    })
  },
  teamRoleBar: {
    /**
     * @analitica When the team role banner is displayed on the sidebar
     */
    viewed: ({ eventName, properties }: Analytics) => ({
      label: eventName,
      metadata: { ...properties }
    }),
    /**
     * @analitica When the user click on the team role banner
     */
    clicked: ({ eventName, properties }: Analytics) => ({
      label: eventName,
      metadata: { ...properties }
    })
  },
  balanceCard: {
    hideBalance: (option: 'hide' | 'show') => ({
      label: 'button-clicked',
      metadata: {
        ...commonProperties,
        reference: 'Ocultar saldo',
        button_id: 'hide_balance',
        option: option
      }
    }),
    actionClick: ({ eventName, type, properties }: Analytics) => ({
      label: eventName,
      metadata: {
        type,
        properties
      }
    })
  },
  profileMenu: {
    click: () => ({
      label: 'button-clicked',
      metadata: {
        ...commonProperties,
        reference: 'Seletor de Contas',
        button_id: 'account_selector'
      }
    })
  },

  accountSelector: {
    /**
     * @analitica When the user click on lateral menu
     */
    accountSearch: (usageTracking: null | string, accountList: number | null) => ({
      label: 'account.selector-page.viewed',
      metadata: {
        account_searched: usageTracking,
        account_list: accountList
      }
    }),
    selectAccountClick: ({
      organizationId,
      approvalStatus,
      searchField,
      accountList
    }: {
      organizationId: string
      approvalStatus: string | undefined
      searchField: string | null
      accountList: number | null
    }) => ({
      label: 'button-clicked',
      metadata: {
        ...commonProperties,
        reference: 'Seletor de Contas: Conta selecionada',
        button_id: 'account_selector',
        organization_id: organizationId,
        approval_status: approvalStatus,
        search_field: searchField,
        account_list: accountList
      }
    })
  }
})
